export default __webpack_public_path__ + "static/media/logo192x192.f7d30478.png";